export const isPlainNumberString = (value: string) => /^-?\d+([.,]\d+)?$/.test(value.trim());
